import React from 'react'
import { ListChecks } from 'lucide-react'
import ContentRenderer from '../../../components/ContentRenderer'
import { cardToContentItems } from '../lib/cardToContentItem'
import { genId } from '../lib/id'
import type { QuizCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

// Phase A: hiển thị khung. Việc lấy câu hỏi từ ngân hàng số hoá pmaker
// sẽ được nối ở Phase E (nút "Lấy câu hỏi từ pmaker").
const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as QuizCard
  return (
    <div className="space-y-3">
      <div className="p-3 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-700 text-sm">
        Thẻ trắc nghiệm sẽ lấy câu hỏi từ <strong>ngân hàng số hoá pmaker</strong>. Tích hợp ở Phase E.
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase">Thời gian (giây)</label>
          <input
            type="number"
            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
            value={c.timeLimit ?? ''}
            onChange={(e) => onChange({ timeLimit: e.target.value ? Number(e.target.value) : undefined })}
          />
        </div>
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase">Điểm đạt (%)</label>
          <input
            type="number"
            className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
            value={c.passingScore ?? ''}
            onChange={(e) => onChange({ passingScore: e.target.value ? Number(e.target.value) : undefined })}
          />
        </div>
      </div>
      <p className="text-xs text-gray-400">Số câu hỏi hiện có: {c.questions?.length ?? 0}</p>
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const c = card as QuizCard
  if (!c.questions || c.questions.length === 0) {
    return (
      <div className="p-4 rounded-lg bg-gray-50 border border-dashed border-gray-200 text-gray-400 text-sm text-center">
        Chưa có câu hỏi. Thêm câu hỏi từ ngân hàng pmaker (Phase E).
      </div>
    )
  }
  const items = cardToContentItems(card)
  return items ? <ContentRenderer content={items} /> : null
}

export const quizCardDef: CardDef = {
  type: 'quiz',
  label: 'Trắc nghiệm',
  description: 'Câu hỏi từ ngân hàng pmaker',
  icon: ListChecks,
  color: 'bg-indigo-50 text-indigo-600',
  createDefault: (): QuizCard => ({ id: genId(), type: 'quiz', source: 'pmaker', questions: [] }),
  Editor,
  Preview,
}
